import React, {useEffect, useState } from "react";
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";
import VariableSelectWrite from "../../../GlobalComponent/VariableSelectWrite";
import { SegmentedControl } from '@mantine/core';

const TypeText = (props) => {
    const [dataState, setDataState] = useState({
        intervalTime: props?.nodeData?.data?.options?.intervalTime ?? 100,
        typeText: props?.nodeData?.data?.options?.typeText ?? "",
        delayType: props?.nodeData?.data?.options?.delayType ?? 'fixed',
        randomDelayFrom: props?.nodeData?.data?.options?.randomDelayFrom ?? 60,
        randomDelayTo: props?.nodeData?.data?.options?.randomDelayTo ?? 120,
    });

    const handleSelector = (type, value) => {
        if (typeof value === 'string' || typeof value === 'number') {
            setDataState({ ...dataState, [type]: value });
        } else {
            setDataState({ ...dataState, [type]: value.target.value });
        }
    }

    useEffect(() => {
        props.handleSetDataBaseModal(dataState)
    }, [props, dataState])

    return (
        <>
            <VariableSelectWrite
                placeholder=""
                label="Enter Text"
                dataState={dataState.typeText}
                handleData={(e) => {
                    handleSelector('typeText', e)
                }}
                handleSelect={(e) => {
                    handleSelector('typeText', e.newValue)
                }}
            />
            <SegmentedControl
                data={[
                    { label: 'Fixed time', value: 'fixed' },
                    { label: 'Random', value: 'random' },
                ]}
                value={dataState.delayType}
                onChange={(value) => handleSelector('delayType', value)}
                style={{ marginTop: 12 }}
            />
            {
                dataState.delayType === 'fixed' ? (
                    <VariableNumberInput
                        label="Enter interval time  (milliseconds)"
                        dataState={dataState.intervalTime}
                        handleData={(e) => {
                            handleSelector('intervalTime',e)
                        }}
                        isMillisecond={true}
                    />
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            gap: 4,
                        }}
                    >
                        <VariableNumberInput
                            label="From delay (milliseconds)"
                            dataState={dataState.randomDelayFrom}
                            handleData={(e) => {

                                handleSelector('randomDelayFrom',e)
                            }}
                            isMillisecond={true}
                            style={{ flex: 1 }}
                        />
                        <VariableNumberInput
                            label="To delay (milliseconds)"
                            dataState={dataState.randomDelayTo}
                            handleData={(e) => {

                                handleSelector('randomDelayTo',e)
                            }}
                            isMillisecond={true}
                            style={{ flex: 1 }}
                        />
                    </div>
                )
            }
        </>
    )
}

export default TypeText;